<template>
  <div class="col-12">
    <hr />
    <EditorGroupToggle
      label="Training Module"
      target="toggleGroupModule"
      class="mb-4"
      :collapsed="false"
    />
    <div id="toggleGroupModule" class="collapse show row">
      <div class="col-12 col-xl-3 mb-3">
        <Field
          type="select"
          name="module_source"
          label="Source"
          v-model="moduleSource"
          :options="trainingTypes"
          :hideSelectEmptyOption="true"
        />
      </div>
      <template v-if="moduleSource == 'HOSTED'">
        <div class="col-12 col-xl-9 mb-3">
          <Field type="text" name="module_path" label="Launch File" :value="course.module_path" />
        </div>
        <div class="col-12 col-xl-3 mb-3">
          <Field
            type="select"
            name="module_type"
            label="Module Type"
            :value="course.module_type"
            :options="moduleTypes"
            :hideSelectEmptyOption="true"
          />
        </div>
        <div class="col-12 col-xl-3 mb-3">
          <Field
            type="select"
            name="module_completion_verb"
            label="Completion Verb"
            :value="course.module_completion_verb"
            :options="completionVerbs"
            :hideSelectEmptyOption="true"
            help-text="The xAPI verb or SCORM lesson status that indicates completion for this module"
          />
        </div>
        <div class="col-12 col-xl-3 mb-3">
          <Field
            type="text"
            name="expiration"
            label="Course Expiration (in days)"
            :value="course.expiration"
          />
        </div>
        <div class="col-12 col-xl-3 mb-3">
          <Field
              type="text"
              name="xapi_activity_id"
              label="xAPI Activity ID"
              :value="course.xapi_activity_id"
          />
          <input type="hidden" name="module_type" value="XAPI" />
        </div>
      </template>
      <template v-else-if="moduleSource == 'EXTERNAL'">
        <div class="col-12 col-xl-9 mb-3">
          <Field type="text" name="module_path" label="Launch URL" :value="course.module_path" />
        </div>
        <div class="col-12 col-xl-3 mb-3">
          <Field
            type="select"
            name="meta[external_vendor]"
            label="Third-Party Vendor"
            :value="course.external_vendor"
            :options="externalVendors"
            :hideSelectEmptyOption="true"
          />
        </div>
        <div class="col-12 col-xl-3 mb-3">
          <Field
            type="text"
            name="external_id"
            label="Third-Party Course ID"
            :value="course.external_id"
          />
        </div>
        <div class="col-12 col-xl-3 mb-3">
          <Field
            type="text"
            name="xapi_activity_id"
            label="xAPI Activity ID"
            :value="course.xapi_activity_id"
          />
          <input type="hidden" name="module_type" value="XAPI" />
        </div>
        <div class="d-none d-xl-flex col-xl-3"></div>
        <div class="col-12 col-xl-3 mb-3">
          <Field
            type="select"
            name="module_completion_verb"
            label="Completion Verb"
            :value="course.module_completion_verb"
            :options="completionVerbs"
            :hideSelectEmptyOption="true"
            help-text="The xAPI verb or SCORM lesson status that indicates completion for this module"
          />
        </div>
        <div class="col-12 col-xl-3 mb-3">
          <Field
            type="text"
            name="expiration"
            label="Course Expiration (in days)"
            :value="course.expiration"
          />
        </div>
        <div class="d-none d-xl-flex col-xl-6"></div>
      </template>
      <template v-else-if="moduleSource == 'LESSON_SERIES'">
        <div class="col-12 col-xl-3 mb-3">
          <Field
            type="text"
            name="expiration"
            label="Course Expiration (in days)"
            :value="course.expiration"
          />
        </div>
        <div class="d-none d-xl-flex col-xl-6"></div>
        <div class="col-12 mb-3">
          <EditLessonSeries :value="course._lessons" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import EditLessonSeries from "./EditLessonSeries";
export default {
  components: { EditLessonSeries },
  props: {
    course: { type: Object, required: true },
    trainingTypes: { type: Array, required: true },
    moduleTypes: { type: Array, required: true },
    externalVendors: { type: Array, required: true },
    completionVerbs: { type: Array, required: true }
  },
  data() {
    return {
      moduleSource: null
    };
  },
  mounted() {
    this.moduleSource = this.course.module_source || null;
  }
};
</script>